module.exports = __webpack_public_path__ + "7befe9536da661aa4800da0632cc37ee.png";